module.exports = __webpack_public_path__ + "media/images/orion_pictos/here-pointer-823fe3a3ddb4b5c87e4a77f2c5a5c974.svg";